import React from "react";

import { IResumeIntro } from "Views/KYX/@types";

import styles from "./index.module.scss";

export const ResumeIntroHeader = ({ companyName }: IResumeIntro) => {
  return <h1 className={styles.title}>Welcome back, {companyName}</h1>;
};
